import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ApiConfig } from '@sp-core/api-config';

// Sends the backend-managed `device_id` HttpOnly cookie with API calls so the BE can
// identify the browser profile (device registration / anti-cheaters). The FE never reads
// or writes the cookie — it only needs the credentialed transport. Scoped to the API host
// so third-party requests (e.g. S3 uploads) are untouched.
@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(ApiConfig.baseAPIPath)) {
      return next.handle(req);
    }

    const credentialedReq = req.clone({ withCredentials: true });
    return next.handle(credentialedReq);
  }
}
